import { lazy } from "react";
import "./web/grades.css";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";
import { gated } from "./web/Feature.js";

const FuelPage = lazy(() => import("./web/FuelPage.js").then((m) => ({ default: m.FuelPage })));
const PricingPage = lazy(() => import("./web/PricingPage.js").then((m) => ({ default: m.PricingPage })));
const ChecksPage = lazy(() => import("./web/ChecksPage.js").then((m) => ({ default: m.ChecksPage })));
const MarginPage = lazy(() => import("./web/MarginPage.js").then((m) => ({ default: m.MarginPage })));
const LedgerPage = lazy(() => import("./web/MarginPage.js").then((m) => ({ default: m.LedgerPage })));
const CostsPage = lazy(() => import("./web/MarginPage.js").then((m) => ({ default: m.CostsPage })));
const FuturePage = lazy(() => import("./web/FuturePage.js").then((m) => ({ default: m.FuturePage })));
const DataPage = lazy(() => import("./web/DataPage.js").then((m) => ({ default: m.DataPage })));
const SettingsPage = lazy(() => import("./web/SettingsPage.js").then((m) => ({ default: m.SettingsPage })));
const CompliancePage = lazy(() => import("./web/CompliancePage.js").then((m) => ({ default: m.CompliancePage })));

// Fuel review C (23/10/26): each feature's pages are behind its yes / no switch in Fuel settings → Features.
export default defineWebModule({ manifest, pages: {
  "": FuelPage, "/pricing": gated("pricing", PricingPage), "/checks": gated("checks", ChecksPage, "fuel.checks"), "/margin": gated("margins", MarginPage),
  "/margin/ledger": gated("future", LedgerPage), "/margin/costs": gated("future", CostsPage), "/margin/future": gated("future", FuturePage),
  "/data": DataPage, "/settings": SettingsPage, "/link-sites": SettingsPage, "/fuel-finder": gated("fuel_finder", CompliancePage),
} });
